import { Icon } from '../../icon';
import { Space } from '../../space';
import { Text } from '../../typography';

export type UploadButtonType = 'bulk' | 'single';

type P = {
  text?: string;
  type?: UploadButtonType;
};

// TODO: Move to react-components
const UploadButton = ({ text, type }: P) => (
  <Space className="event-attachments-upload-button" orientation="vertical" size="medium">
    <Icon className="event-attachments-upload-button__icon" icon="attachment-line" type="secondary" />
    <Space orientation="vertical" size="small">
      <Text size="large" type="title" weight="medium">
        {text ?? 'Click or drag file to this area to upload'}
      </Text>
      {type ? (
        <Text>{type === 'bulk' ? 'Support for a single or bulk upload.' : 'Support for a single file only.'}</Text>
      ) : null}
    </Space>
  </Space>
);

export default UploadButton;
